/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupDetail
 */
export interface UserGroupDetail {
    /**
     * 
     * @type {number}
     * @memberof UserGroupDetail
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserGroupDetail
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof UserGroupDetail
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof UserGroupDetail
     */
    imageId: string;
    /**
     * 
     * @type {number}
     * @memberof UserGroupDetail
     */
    state: number;
    /**
     * 
     * @type {string}
     * @memberof UserGroupDetail
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupDetail
     */
    highscoreStrategyDescriptorId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupDetail
     */
    highscoreStrategyDescriptorName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetail
     */
    loginUserIsGroupAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetail
     */
    loginUserIsGroupMember: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetail
     */
    loginUserIsInvited: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetail
     */
    loginUserIsApplying: boolean;
}

/**
 * Check if a given object implements the UserGroupDetail interface.
 */
export function instanceOfUserGroupDetail(value: object): value is UserGroupDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('imageId' in value) || value['imageId'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('loginUserIsGroupAdmin' in value) || value['loginUserIsGroupAdmin'] === undefined) return false;
    if (!('loginUserIsGroupMember' in value) || value['loginUserIsGroupMember'] === undefined) return false;
    if (!('loginUserIsInvited' in value) || value['loginUserIsInvited'] === undefined) return false;
    if (!('loginUserIsApplying' in value) || value['loginUserIsApplying'] === undefined) return false;
    return true;
}

export function UserGroupDetailFromJSON(json: any): UserGroupDetail {
    return UserGroupDetailFromJSONTyped(json, false);
}

export function UserGroupDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'date': (new Date(json['date'])),
        'imageId': json['imageId'],
        'state': json['state'],
        'description': json['description'] == null ? undefined : json['description'],
        'highscoreStrategyDescriptorId': json['highscoreStrategyDescriptorId'] == null ? undefined : json['highscoreStrategyDescriptorId'],
        'highscoreStrategyDescriptorName': json['highscoreStrategyDescriptorName'] == null ? undefined : json['highscoreStrategyDescriptorName'],
        'loginUserIsGroupAdmin': json['loginUserIsGroupAdmin'],
        'loginUserIsGroupMember': json['loginUserIsGroupMember'],
        'loginUserIsInvited': json['loginUserIsInvited'],
        'loginUserIsApplying': json['loginUserIsApplying'],
    };
}

export function UserGroupDetailToJSON(value?: UserGroupDetail | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'date': ((value['date']).toISOString()),
        'imageId': value['imageId'],
        'state': value['state'],
        'description': value['description'],
        'highscoreStrategyDescriptorId': value['highscoreStrategyDescriptorId'],
        'highscoreStrategyDescriptorName': value['highscoreStrategyDescriptorName'],
        'loginUserIsGroupAdmin': value['loginUserIsGroupAdmin'],
        'loginUserIsGroupMember': value['loginUserIsGroupMember'],
        'loginUserIsInvited': value['loginUserIsInvited'],
        'loginUserIsApplying': value['loginUserIsApplying'],
    };
}

